import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { CreateExportInterfaceFieldAssignmentTemplateDTO, ExportInterfaceConfigurationType, ExportInterfaceFieldAssignmentTemplateClient, ExportInterfaceFieldAssignmentTemplateDTO, FilterDTO, FilterOperator, SortDirection, UpdateExportInterfaceEmailTemplateDTO, UpdateExportInterfaceFieldAssignmentTemplateDTO } from "src/app/base/models/models.swagger.generated";
import { ToastService } from "src/app/base/services/toast.service";
import { ShowInactiveService } from "src/app/base/shared/grid-base/show-inactive.service";
import { IAdaptorService } from "src/app/base/shared/syncfusion/adaptor-service.interface";
import { IPagedItems } from "src/app/base/shared/syncfusion/paged-items.interface";
import { ErrorType } from "src/app/core/routing/error-types";

@Injectable()
export class FieldAssignmentTemplatesOverviewService extends ShowInactiveService implements IAdaptorService {
  constructor(
    private fieldTemplateClient: ExportInterfaceFieldAssignmentTemplateClient,
    private toastService: ToastService)
  {
    super();
  }

  public configurationType: ExportInterfaceConfigurationType;
  public doIgnoreTypeFilter: boolean = false;
  public oneTimeFilterTemplateId: number;
  
  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    if (!sortBy) {
      sortBy = 'TemplateName';
    }
    if (filters == null) {
      filters = [];
    }
    if (this.configurationType != null && !this.doIgnoreTypeFilter) {
      filters.push(new FilterDTO({
        isComplex: false,
        field: "ConfigurationType",
        operator: FilterOperator.Equal,
        value: this.configurationType.toString()
      }));
    }
    if (this.oneTimeFilterTemplateId) {
      filters.push(new FilterDTO({ field: 'id', operator: FilterOperator.Equal, value: this.oneTimeFilterTemplateId.toString(), isComplex: false}));
      this.oneTimeFilterTemplateId = null;
    }
    return this.fieldTemplateClient.searchExportInterfaceFieldAssignmentTemplates(skip, take, sortBy, sortDirection, false, filters);
  }

  public addRecord(): Observable<ExportInterfaceFieldAssignmentTemplateDTO> {
    return this.fieldTemplateClient.createDefaultExportInterfaceFieldAssignmentTemplate()
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.export-configuration.field-assignment-templates.messages.create.success-title',
            'i18n.domain.export-configuration.field-assignment-templates.messages.create.success-message',
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public updateRecord(updateTemplate: UpdateExportInterfaceFieldAssignmentTemplateDTO): Observable<ExportInterfaceFieldAssignmentTemplateDTO> {
    return this.fieldTemplateClient.updateExportInterfaceFieldAssignmentTemplate(updateTemplate)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.export-configuration.field-assignment-templates.messages.update.success-title',
            'i18n.domain.export-configuration.field-assignment-templates.messages.update.success-message',
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
          }
          return throwError(() => error);
        }),
      );
  }

  public deleteRecord(id: number) {
    return this.fieldTemplateClient.deleteExportInterfaceFieldAssignmentTemplate(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.export-configuration.field-assignment-templates.messages.delete.success-title',
            'i18n.domain.export-configuration.field-assignment-templates.messages.delete.success-message',
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public createNewTemplate(createTemplate: CreateExportInterfaceFieldAssignmentTemplateDTO) {
    return this.fieldTemplateClient.createExportInterfaceFieldAssignmentTemplate(createTemplate)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.export-configuration.field-assignment-templates.messages.create.success-title',
            'i18n.domain.export-configuration.field-assignment-templates.messages.create.success-message',
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}
